module.exports = __webpack_public_path__ + "videos/3d-export_cn.37ac39f.webm";